<template>
  <v-container
    :class="{ even: even }"
    a-0
    class="wrapper"
    fluid
    px-md-12
    py-12
    ma-0
  >
    <v-row align="center" ma-0>
      <v-col class="px-md-8" cols="12" lg="5" md="12" xs="12">
        <h2 class="display-1 mb-5 mb-md-5 text-title text-center text-md-left">
          Nossa base: Tecnologia
        </h2>
        <p class="body-1 text-left ma-0 mb-md-7 text-body">
          Um dos principais diferenciais da solução eu<b>reciclo</b> é a nossa
          tecnologia de rastreamento. Ela tem início na homologação dos
          operadores de triagem e consegue garantir, através das notas fiscais
          emitidas por eles, a destinação correta de embalagens pós-consumo para
          a reciclagem.
        </p>
      </v-col>
      <v-col class="pa-0 pl-md-10" cols="12" lg="7" md="12" xs="12">
        <v-row justify="center" no-gutters>
          <v-col
            v-for="(base, i) in bases"
            :key="i"
            align="center"
            cols="6"
            sm="4"
            class="mt-4 mt-sm-0"
          >
            <div class="solution">
              <v-img
                :src="base.image"
                contain
                max-height="300"
                class="rounded-image solutions-img"
              />
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="sass" scoped>
@import '@/styles/util'
@import '@/styles/style'

.wrapper
  background-color: #01ee55

.even
  background-color: white

.text-title
  font-size: 1.6em !important
  color: #fff
  @media screen and (max-width: $sm)
    font-size: 2.2em !important
  @media screen and (max-width: $xs)
    font-size: 1.6em !important

.text-body
  font-family: 'Proxima Nova', sans-serif !important
  font-weight: normal
  font-size: 1.2em !important
  color: #fff
  @media screen and (max-width: $sm)
    font-size: 1.3em !important
  @media screen and (max-width: $xs)
    font-size: 1.1em !important

.solution
  height: 100%
  transition: box-shadow 250ms
  background-color: #fff !important
  margin: 0 10%
  border-radius: 5px
  @media screen and (max-width: $sm)
    margin: 0 5%
  &:hover
    box-shadow: 0px 7px 17px -1px rgba(0,0,0,0.2)

.solution-img
  width: 100%
  max-width: 150px
  @media screen and (max-width: $xs)
    max-width: 100px

.title-solution
  font-family: "Proxima Nova", sans-serif !important
  font-size: 1em !important
  font-weight: bold !important

.description-solution
  font-family: "Proxima Nova", sans-serif !important
  font-size: 0.8em !important
  font-weight: normal !important

.new-color
  .wrapper
    background-color: #26d07c
  .text-body,
  .title-solution,
  .text-title,
  .description-solution
    font-family: 'metropolisregular', sans-serif !important
  .solution
    &:hover
      box-shadow: 0px 7px 17px -1px rgba(0,48,54,0.2)
</style>

<script>
export default {
  name: 'OurBase',
  props: {
    even: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      bases: [
        {
          title: 'Integridade',
          description: `Todos as notas fiscais passam por verificações de integridade e por análise estatística com
                        machine learning para a detecção de fraudes.`,
          image: require('@/assets/images/our-solutions/secao3/integridade.jpg'),
        },
        {
          title: 'Blockchain',
          description: `Os fluxos de cada grupo de material são quantificados por ano e região em cadeias de
                        blockchain e passam a ser Certificados comercializáveis.`,
          image: require('@/assets/images/our-solutions/secao3/blockchain.jpg'),
        },
        {
          title: 'Certificados',
          description: `A empresa recebe um Certificado listando os operadores, notas fiscais e toneladas envolvidos
                        na compensação ambiental de suas embalagens.`,
          image: require('@/assets/images/our-solutions/secao3/certificado.jpg'),
        },
      ],
    };
  },
};
</script>
